import { Icon } from 'ant-design-vue'
export default Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2733983_z41v4yufqxf.js'
})
